import { z } from "zod";
import { localStore } from "../../../lib/store";

/**
 * Which Juisci GPT engine THIS browser asks for, or `null` to take whatever the
 * server serves by default.
 *
 * TEMPORARY, and deliberately per-device rather than per-account: it exists so
 * `gpt-5.6-luna` can be tried in production from one browser — a personal canary
 * — while every other client stays on the incumbent. Switched from the console:
 *
 *     localStorage.setItem("gptEngine", '"luna"'); location.reload();
 *     localStorage.removeItem("gptEngine");        location.reload();
 *
 * The inner quotes are not a typo: `localStore` stores JSON, so a string value is
 * written with them.
 *
 * The two names are spelled out here and also live in the API's engine registry.
 * That duplication cannot drift in silence: the request body is typed by
 * inference from the API contract, so a name the server drops fails the webapp
 * typecheck at the point it is sent.
 *
 * DELETE this store, and the `engine` field it feeds, once luna is the default
 * server-side (see service/llm-gateway.ts for the criterion).
 */
export const gptEngineStore = localStore(
  "gptEngine",
  null,
  z.enum(["luna", "legacy"]).nullable()
);
